var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _vm.showSearchBtn
        ? _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "query-form",
              attrs: { size: "small", inline: true, model: _vm.params },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.refreshList()
                },
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm._l(
                _vm.dataBindFields.filter(function (field) {
                  return field.isSearch
                }),
                function (option, index) {
                  return _c(
                    "el-form-item",
                    { key: index, attrs: { prop: option.model } },
                    [
                      option.type === "user"
                        ? _c("user-select", {
                            attrs: { size: "small" },
                            on: {
                              getValue: function (value, label) {
                                _vm.params["" + option.model] = value
                              },
                            },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          })
                        : option.type === "office"
                        ? _c("SelectTree", {
                            attrs: {
                              size: "small",
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/office/treeData",
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.params["" + option.model] = value
                              },
                            },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          })
                        : option.type === "area"
                        ? _c("SelectTree", {
                            attrs: {
                              size: "small",
                              props: {
                                value: "id", // ID字段名
                                label: "name", // 显示名称
                                children: "children", // 子级字段名
                              },
                              url: "/sys/area/treeData",
                              clearable: true,
                              accordion: true,
                            },
                            on: {
                              getValue: function (value) {
                                _vm.params["" + option.model] = value
                              },
                            },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          })
                        : option.type === "dict"
                        ? _c(
                            "el-select",
                            {
                              attrs: { size: "small" },
                              model: {
                                value: _vm.params["" + option.model],
                                callback: function ($$v) {
                                  _vm.$set(_vm.params, "" + option.model, $$v)
                                },
                                expression: "params[`${option.model}`]",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList(
                                "" + option.options.dictType
                              ),
                              function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : option.type === "time"
                        ? _c("el-time-picker", {
                            attrs: { size: "small", placeholder: option.name },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          })
                        : option.type === "date"
                        ? _c("el-date-picker", {
                            attrs: { size: "small", placeholder: option.name },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          })
                        : _c("el-input", {
                            attrs: { size: "small", placeholder: option.name },
                            model: {
                              value: _vm.params["" + option.model],
                              callback: function ($$v) {
                                _vm.$set(_vm.params, "" + option.model, $$v)
                              },
                              expression: "params[`${option.model}`]",
                            },
                          }),
                    ],
                    1
                  )
                }
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.refreshList()
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh-right" },
                      on: {
                        click: function ($event) {
                          return _vm.resetSearch()
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: { title: "导入Excel", visible: _vm.isImportCollapse },
          on: {
            "update:visible": function ($event) {
              _vm.isImportCollapse = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "importForm",
              staticClass: "query-form",
              attrs: { size: "small", inline: true },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "default", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.downloadTpl()
                        },
                      },
                    },
                    [_vm._v("下载模板")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "loginName" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: this.$http.BASE_URL + "/form/generate/import",
                        "on-success": _vm.uploadSuccess,
                        data: {
                          formId: this.$route.query.id,
                        },
                        "show-file-list": true,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("点击上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v("只允许导入“xls”或“xlsx”格式文件！")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "bg-white",
          style: _vm.showSearchBtn ? "height:calc(100% - 76px)" : "height:100%",
        },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _vm.$route.query.previewMode ||
                    _vm.hasPermission("form:" + _vm.tableName + ":add")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.add()
                              },
                            },
                          },
                          [_vm._v("新建")]
                        )
                      : _vm._e(),
                    _vm.$route.query.previewMode ||
                    _vm.hasPermission("form:" + _vm.tableName + ":edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "small",
                              icon: "el-icon-edit-outline",
                              disabled:
                                _vm.$refs.table &&
                                _vm.$refs.table.getCheckboxRecords().length !==
                                  1,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.edit()
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm.$route.query.previewMode ||
                    _vm.hasPermission("form:" + _vm.tableName + ":del")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "small",
                              icon: "el-icon-delete",
                              disabled:
                                _vm.$refs.table &&
                                _vm.$refs.table.getCheckboxRecords().length ===
                                  0,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.del()
                              },
                            },
                          },
                          [_vm._v("删除 ")]
                        )
                      : _vm._e(),
                    _vm._l(
                      _vm.options.config.actions.filter(function (action) {
                        return (
                          action.position.indexOf("1") > -1 &&
                          (_vm.$route.query.previewMode ||
                            !action.auth ||
                            _vm.hasPermission(action.auth))
                        )
                      }),
                      function (item, index) {
                        return _c(
                          "el-button",
                          {
                            key: index,
                            attrs: {
                              disabled:
                                _vm.$refs.table &&
                                _vm.$refs.table.getCheckboxRecords().length !==
                                  1,
                              size: "small",
                              icon: "el-icon-link",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.go(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      }
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "table",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {},
                    "export-config": {},
                    "sort-config": { remote: true },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _vm._l(
                    _vm.dataBindFields.filter(function (item) {
                      return item.isShow
                    }),
                    function (option, index) {
                      return _c("vxe-column", {
                        key: option.model,
                        attrs: {
                          field: option.model,
                          "show-overflow-tooltip": "",
                          sortable: option.isSort ? true : false,
                          title: option.name,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  option.type === "html"
                                    ? _c("div", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            scope.row["" + option.model]
                                          ),
                                        },
                                      })
                                    : option.type === "color"
                                    ? _c(
                                        "div",
                                        [
                                          _c("el-color-picker", {
                                            attrs: { disabled: "" },
                                            model: {
                                              value:
                                                scope.row["" + option.model],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "" + option.model,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row[`${option.model}`]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : option.type === "editor"
                                    ? _c("div", [
                                        _c("p", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$utils.unescapeHTML(
                                                scope.row["" + option.model] ||
                                                  ""
                                              )
                                            ),
                                          },
                                        }),
                                      ])
                                    : option.type === "imgupload"
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          JSON.parse(
                                            scope.row["" + option.model] || "[]"
                                          ),
                                          function (item, index) {
                                            return _c("el-image", {
                                              key: index,
                                              staticStyle: {
                                                height: "50px",
                                                width: "50px",
                                                "margin-right": "10px",
                                              },
                                              attrs: {
                                                src: item.url,
                                                "preview-src-list": JSON.parse(
                                                  scope.row["" + option.model]
                                                ).map(function (item) {
                                                  return item.url
                                                }),
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : option.type === "fileupload"
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          JSON.parse(
                                            scope.row["" + option.model] || "[]"
                                          ),
                                          function (item, index) {
                                            return _c(
                                              "a",
                                              {
                                                key: index,
                                                attrs: {
                                                  href: item.url,
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      decodeURIComponent(
                                                        item.url.substring(
                                                          item.url.lastIndexOf(
                                                            "&name="
                                                          ) + 6
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : option.type === "dict"
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$dictUtils.getDictLabel(
                                                "" + option.options.dictType,
                                                scope.row["" + option.model]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : option.type === "selectTree"
                                    ? _c(
                                        "div",
                                        [
                                          _c("TreeSelectText", {
                                            attrs: {
                                              size: "small",
                                              props: {
                                                value: "id", // ID字段名
                                                label: "name", // 显示名称
                                                children: "children", // 子级字段名
                                              },
                                              url: option.options.dataUrl,
                                              clearable: true,
                                              accordion: true,
                                            },
                                            model: {
                                              value:
                                                scope.row["" + option.model],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  "" + option.model,
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "scope.row[`${option.model}`]",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : option.type === "checkbox" &&
                                      option.options.remote === 3
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          JSON.parse(
                                            scope.row["" + option.model] || "[]"
                                          ),
                                          function (item, index) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dictUtils.getDictLabel(
                                                      "" +
                                                        option.options.dictType,
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              index + 1 !==
                                              JSON.parse(
                                                scope.row["" + option.model] ||
                                                  "[]"
                                              ).length
                                                ? _c("span", [_vm._v(" | ")])
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : option.type === "select" &&
                                      option.options.remote === 3 &&
                                      option.options.multiple
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          JSON.parse(
                                            scope.row["" + option.model] || "[]"
                                          ),
                                          function (item, index) {
                                            return _c("span", { key: index }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dictUtils.getDictLabel(
                                                      "" +
                                                        option.options.dictType,
                                                      item
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              index + 1 !==
                                              JSON.parse(
                                                scope.row["" + option.model] ||
                                                  "[]"
                                              ).length
                                                ? _c("span", [_vm._v(" | ")])
                                                : _vm._e(),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : option.type === "select" &&
                                      option.options.remote === 3 &&
                                      !option.options.multiple
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$dictUtils.getDictLabel(
                                                "" + option.options.dictType,
                                                scope.row["" + option.model]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : option.type === "radio" &&
                                      option.options.remote === 3
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$dictUtils.getDictLabel(
                                                "" + option.options.dictType,
                                                scope.row["" + option.model]
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _c("div", [
                                        index === 0
                                          ? _c(
                                              "div",
                                              [
                                                _vm.$route.query.previewMode ||
                                                _vm.hasPermission(
                                                  "form:" +
                                                    _vm.tableName +
                                                    ":edit"
                                                )
                                                  ? _c(
                                                      "el-link",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          underline: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.edit(
                                                              scope.row.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              "" + option.model
                                                            ] || ""
                                                          ) + " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.$route.query
                                                      .previewMode ||
                                                    _vm.hasPermission(
                                                      "form:" +
                                                        _vm.tableName +
                                                        ":view"
                                                    )
                                                  ? _c(
                                                      "el-link",
                                                      {
                                                        attrs: {
                                                          type: "primary",
                                                          underline: false,
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.view(
                                                              scope.row.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            scope.row[
                                                              "" + option.model
                                                            ] || ""
                                                          ) + " "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row[
                                                            "" + option.model
                                                          ] === undefined
                                                            ? ""
                                                            : scope.row[
                                                                "" +
                                                                  option.model
                                                              ]
                                                        ) + " "
                                                      ),
                                                    ]),
                                              ],
                                              1
                                            )
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row[
                                                    "" + option.model
                                                  ] === undefined
                                                    ? ""
                                                    : scope.row[
                                                        "" + option.model
                                                      ]
                                                ) + " "
                                              ),
                                            ]),
                                      ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      })
                    }
                  ),
                  _c("vxe-column", {
                    attrs: {
                      title: "操作",
                      width: "200px",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.$route.query.previewMode ||
                            _vm.hasPermission("form:" + _vm.tableName + ":view")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-view",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(" 查看 ")]
                                )
                              : _vm._e(),
                            _vm.$route.query.previewMode ||
                            _vm.hasPermission("form:" + _vm.tableName + ":edit")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-edit",
                                      size: "mini",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(" 修改 ")]
                                )
                              : _vm._e(),
                            _vm.$route.query.previewMode ||
                            _vm.hasPermission("form:" + _vm.tableName + ":del")
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v(" 删除 ")]
                                )
                              : _vm._e(),
                            _vm._l(
                              _vm.options.config.actions.filter(function (
                                action
                              ) {
                                return (
                                  action.position.indexOf("2") > -1 &&
                                  (_vm.$route.query.previewMode ||
                                    !action.auth ||
                                    _vm.hasPermission(action.auth))
                                )
                              }),
                              function (item, index) {
                                return _c(
                                  "el-button",
                                  {
                                    key: index,
                                    attrs: {
                                      type: "text",
                                      size: "mini",
                                      icon: "el-icon-link",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.go(item, scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.name) + " ")]
                                )
                              }
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                2
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
              _c("GenerateForm", {
                ref: "previewForm",
                on: { refreshDataList: _vm.refreshList },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }